<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Block User</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<hr class="m-0 p-0">
<mat-dialog-content>
  <p class="mb-2">Blocking this user takes effect immediately:</p>
  <ul class="mb-3">
    <li>They are signed out of all devices and their personal API tokens are revoked.</li>
    <li>They cannot sign in or reset their password. Kiosk and QR code site sign-ins are refused too.</li>
    <li>Their account memberships are kept. Each client will see them flagged as Blocked in their Employees list.</li>
    <li>Pending access requests stay pending but cannot be approved. The client can still decline them.</li>
  </ul>
  <p class="mb-3">
    This user is a member of <strong>{{ data.accounts_count }}</strong> account(s).
  </p>
  <div class="alert alert-warning mb-3" role="alert" *ngIf="data.is_partner">
    This user is an active partner. Partner roles and provisioning are not removed. The partner sync keeps
    running for approved memberships, but a pending partner link will not be approved while they are blocked.
  </div>
  <div class="alert alert-info mb-3" role="alert">
    If this user is the login a kiosk runs under, that kiosk will be signed out.
  </div>
  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Reason (internal, only super admins see this)</mat-label>
    <textarea
      matInput
      rows="3"
      name="reason"
      [(ngModel)]="reason"
      [minlength]="reasonMinLength"
      [maxlength]="reasonMaxLength"
      required></textarea>
    <mat-hint align="end">{{ (reason || '').length }} / {{ reasonMaxLength }}. Minimum {{ reasonMinLength }} characters.</mat-hint>
  </mat-form-field>
  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Reason shown to the client (optional)</mat-label>
    <textarea
      matInput
      rows="2"
      name="client_note"
      [(ngModel)]="clientNote"
      [maxlength]="reasonMaxLength"></textarea>
    <mat-hint align="end">{{ (clientNote || '').length }} / {{ reasonMaxLength }}. Shown in the Employees list of every account the user belongs to.</mat-hint>
  </mat-form-field>
</mat-dialog-content>
<hr class="m-0 p-0">
<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="warn" [disabled]="!canSubmit" (click)="onBlock()">
      <mat-icon>block</mat-icon> Block User
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button mat-dialog-close>
      Cancel
    </button>
  </div>
</mat-dialog-actions>
